import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CognitoContext, UserProviderActions } from "../../contexts/cognito/cognito-provider";
import { AppRouteNames } from "../../routes/app-routes";
import { CurrentUserStorage } from "../../library/core/current-user";
import { useAppLoading } from "../../components/layout/app-loading-provider";
import { buildUserSession } from "../../library/cognito/session";


const AuthorisedPage = ({children})=>{
    const navigate = useNavigate();
    const location = useLocation();
    const {state, dispatch} = useContext(CognitoContext);
    const { showLoading, hideLoading } = useAppLoading();

    const targetUrl = encodeURI(`${location.pathname}${location.search}`);
    const signinPath = `${AppRouteNames.signin}?url=${targetUrl}`;
    
    // state.cognitoUser.signOut(()=>{
    //     dispatch({type: UserProviderActions.signout});
    //     navigate(AppRouteNames.signin)
    // });
    
    

    const navigateToLogin = ()=>{
        CurrentUserStorage.clearSession();
        dispatch({
            type: UserProviderActions.setSession, 
            session: null
        });
        navigate(signinPath);
    };

    
   
    useEffect(()=>{
        if(state.session){
            hideLoading();
            return;
        }

        showLoading();

        var cognitoUser = state.userPool.getCurrentUser();

        if(cognitoUser === null)
        {
            hideLoading();
            navigateToLogin();
            return;
        }

        dispatch({
            type: UserProviderActions.setCognitoUser,
            cognitoUser
        });

        cognitoUser.getSession((err, session)=>{

            if(err || !session.isValid()){
                hideLoading();
                navigateToLogin();
                return;
            }

            cognitoUser.getUserAttributes(function(err, attributes) {

                if (!err) {
                    const userSession = buildUserSession(session, attributes);

                    dispatch({
                        type: UserProviderActions.setSession,
                        session: userSession
                    });
                    hideLoading();
                }
                else{
                    hideLoading();
                    navigateToLogin();
                }
            });

        });

    },[]);
    
    return children;
};

export {AuthorisedPage};